import { render, staticRenderFns } from "./mandates.vue?vue&type=template&id=28b681b4&scoped=true&"
import script from "./mandates.ts?vue&type=script&lang=ts&"
export * from "./mandates.ts?vue&type=script&lang=ts&"
import style0 from "./mandates.vue?vue&type=style&index=0&id=28b681b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b681b4",
  null
  
)

export default component.exports